import * as React from 'react';
import './ECheckPermissions.scss';
import Button from 'src/components/common/Button';
import Input from 'src/components/common/Input';
import Loader from 'src/components/common/Loader';
import Alert from 'src/components/common/Alert';
import Modal from 'src/components/common/Modal';

import EcheckPermissionModel from 'src/model/echeckPermission.model';

import MUIDataTable, { Responsive } from 'mui-datatables';
import { MuiThemeProvider } from '@material-ui/core/styles';

interface IECheckDisabledUserProps {
  echeckDisabledUsers: EcheckPermissionModel[];
  fetchEcheckDisabledUsers: () => void;
  isPending: boolean;
  hasError: boolean;
  errorMessage: string;
  hasSucceed: boolean;
  EcheckUserStatusToggle(
    usernameArray: string[],
    status: boolean,
  ): void;
  onClearAlert(): void;
}

interface IManagePowerUsersState {
  userName: string;
  disableEcheck: boolean;
  showModal: boolean;
  userModal: { name: string; id: number };
  selectedUsers: string[];
}

class ECheckPermissions extends React.Component<IECheckDisabledUserProps,IManagePowerUsersState> {
  constructor(props: any) {
    super(props);

    this.state = {
      userName: '',
      disableEcheck: false,
      showModal: false,
      userModal: { name: '', id: 0 },
      selectedUsers: [],
    };
  }

  public componentDidMount() {
    this.props.fetchEcheckDisabledUsers();
  }

  private handleShowHideModal = (user: any = '', id: number = 0) => {
    this.setState(prevState => ({
      showModal: !prevState.showModal,
      userModal: { name: user, id }
    }));
  };

  private onEcheckStatusChange = () => {
    this.setState(
      prevState => ({
        disableEcheck: !prevState.disableEcheck
      }),
      () => {
        this.clearUserData();
        this.props.onClearAlert();
      }
    );
  };

  public componentDidUpdate(prevProps: IECheckDisabledUserProps) {
    if (prevProps.echeckDisabledUsers.length !== this.props.echeckDisabledUsers.length) {
      this.props.fetchEcheckDisabledUsers();
    }
  }

  private clearUserData = () => {
    this.setState({
      userName: '',
    });
  };

  private onUserNameChange = (text: string) => {
    this.setState({ selectedUsers: [] });
    this.setState({ userName: text});
  };

  private renderModal = () => {
    return (
      <Modal handleCloseModal={this.handleShowHideModal}>
        <div className="rp-manage-echeck-permissions--modal">
          <span
            className="rpds-close"
            onClick={e => this.handleShowHideModal('', 0)}
          />
          <div className="rp-manage-echeck-permissions--modal-text">{`Are you sure you want to activate echeck payment for selected users?`}</div>
          <div className="rp-manage-echeck-permissions--modal-buttons">
            <button
              className="secondary-button"
              onClick={e => this.handleShowHideModal('', 0)}
            >
              Cancel
            </button>
            <button
              className="primary-button"
              onClick={e => {
                this.props.EcheckUserStatusToggle(this.state.selectedUsers, true);
                setTimeout(() => {
                  this.props.fetchEcheckDisabledUsers();
                }, 1000);
                this.handleShowHideModal('', 0);
              }}
            >
              ACTIVATE
            </button>
          </div>
        </div>
      </Modal>
    );
  };

  private disableEcheckStatus = () => {
    this.state.selectedUsers.push(this.state.userName);
    this.props.EcheckUserStatusToggle(
      this.state.selectedUsers,
      false
    );
  };


  private renderDisableEcheckUser = () => {
    return (
      <React.Fragment>
        {this.props.hasSucceed && (
          <Alert
            styleClass={'rp-power-user-alert'}
            type={'success'}
            icon={'rpds-check-circle'}
            handleCloseAlert={this.props.onClearAlert}
            message={'Echeck disabled for user successfully.'}
          />
        )}
        <div className="rp-manage-echeck-permissions--create">
          <span
            onClick={this.onEcheckStatusChange}
            className="rpds-close rp-manage-echeck-permissions--close-icon"
          />
          <div className="rp-manage-echeck-permissions--create-area">
            <h1 className="rp-manage-echeck-permissions--create-title">
              Disable Echeck for User
            </h1>
            <Input
              label="Account Identity"
              value={this.state.userName}
              onChange={this.onUserNameChange}
              required={true}
            />
            <Button
              label="Disable Echeck for user"
              textTransform="uppercase"
              buttonClass="primary-button"
              action={this.disableEcheckStatus}
            />
          </div>
        </div>
      </React.Fragment>
    );
  };
  
  private columns = [
    {
      label: 'Account Identity',
      name: 'accountId',
      options: {
        filter: true,
      }
    }, 
  {
    label: 'Client Identity',
    name: 'userId',
    options: {
      filter: true,
    }
  },
  {
    label: 'Real Name',
    name: 'name',
    options: {
      filter: false,
    }
  },
  {
    label: 'Client Email',
    name: 'email',
    options: {
      filter: true,
    }
  }]

  private onRowSelectionChange = (
    currentRowsSelected: any,
    allRowsSelected: any,
    rowsSelectedpath: any
  ) => {
    const newSelectedRowsArray: any = [];

    rowsSelectedpath.forEach((userVal: any) => {
      newSelectedRowsArray.push(this.props.echeckDisabledUsers[userVal]);
    });

    const accountIdarray = newSelectedRowsArray.map((element: any) => element.accountId);
    this.setState({
      selectedUsers: accountIdarray
    });
  };


  private options = {
    search: false,
    download: false,
    pagination: false,
    print: false,
    fixedHeader: false,
    responsive: 'standard' as Responsive,
    onRowSelectionChange: this.onRowSelectionChange,
    selectableRows: true as any,
    sort: true,
  };

  
  private renderUserTable = () => {
    return (
      <React.Fragment>
      <div className='action-div'>
      <div>
        <button
              className="primary-button"
              onClick={e => {
                this.handleShowHideModal('', 0);
              }}
            >
              ENABLE ECHECK FOR SELECT USERS
            </button>
            </div>
            <div>
            <button
            className="primary-button"
            onClick={this.onEcheckStatusChange}
          >DISABLE ECHECK FOR USER </button>
          </div>
          </div>
          <MUIDataTable
            title={''}
            data={this.props.echeckDisabledUsers}
            columns={this.columns}
            options={this.options}
          />
        {this.state.showModal && this.renderModal()}
        </React.Fragment>
    );
  };

  public render() {
    return (
      <div className="rp-manage-echeck-permissions">
        <div className="rp-manage-echeck-permissions--content">
        {this.state.disableEcheck
            ? this.renderDisableEcheckUser()
            : this.renderUserTable()}
        </div>
        </div>
    );
  }
}

export default ECheckPermissions;
